module.exports = __webpack_public_path__ + "img/f686c06.png";